
import React, { Fragment, useState } from 'react';
import {
    ShowButton,
    SimpleShowLayout,
    List,
    Edit,
    Create,
    Datagrid,
    TextField,
    EditButton,
    ShowController,
    Show,
    ShowView,
    SelectInput,
    SimpleForm,
    TextInput,
    Filter,
    FormDataConsumer,
    ArrayInput,
    SimpleFormIterator,
    ImageField,
    ArrayField,
    BooleanField,
    BooleanInput,
    ImageInput,
    SelectArrayInput,
    NumberInput,
    NumberField,
    ReferenceInput,
    AutocompleteInput,
    AutocompleteArrayInput,
    useNotify,
    Toolbar,
    SaveButton,
    ReferenceField,
    FileInput,
    FileField,
    SingleFieldList,
    FunctionField,
    DateField,
    DateInput,
    useRecordContext,
    DateTimeInput,
    TopToolbar,
    Button as RaButton,
    useRefresh,
    ReferenceArrayField,
    ReferenceArrayInput,
    ChipField,
    useGetList, useList, useListController, ListContextProvider, useListContext,
    Labeled,
    RecordContextProvider,
    ListBase,
    FilterButton, FilterForm,
} from 'react-admin';

import {
    Divider, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, TextField as MuiTextField,
    Button, Box, CircularProgress, Avatar, CardContent, CardActions, CardHeader, Card, Grid, Typography, CardMedia,
    Stack,
} from '@mui/material';
import { Link, useNavigate } from 'react-router-dom'
import Profile from '../component/Profile'
import client from '../common/client'

const LibraryTitle = () => {
    const record = useRecordContext();
    if (!record) return null;
    return <span>Library</span>;
};

const LibraryFilter = props => (
    <Filter {...props}>
        <TextInput resettable label="id" source="id" alwaysOn />

        {
            //Custom Filter Start

            //Custom Filter End
        }
    </Filter>
);

const postFilters = [
    <TextInput label="Name" source="q" alwaysOn />,
    <ReferenceInput label="Member" source="member_no" reference="user" alwaysOn>
        <AutocompleteInput optionText="email" sx={{width:'300px'}}/>
    </ReferenceInput>
];

const LibraryToolbar = () => (
    <Stack direction="row" justifyContent="space-between">
        <FilterForm filters={postFilters} />
        <div>
            {/* <FilterButton filters={postFilters} /> */}
        </div>
    </Stack>
)

const LibraryGrid = props => {
    const { data, isLoading } = useListContext();
    if (isLoading) {
        return null;
    }

    return (
        <Grid container spacing={2} sx={{ marginTop: '1em' }}>
            {data.map(record => (
                <RecordContextProvider key={record.id} value={record}>
                    <Grid
                        key={record.id}
                        xs={12}
                        sm={6}
                        md={4}
                        lg={4}
                        xl={3}
                        item
                    >
                        <Card>
                            <CardContent sx={{ paddingBottom: '0.5em' }}>
                                <Typography
                                    variant="h5"
                                    component="h2"
                                    align="left"
                                >
                                    {record.name}
                                </Typography>

                                <Typography
                                    variant="body2"
                                    component="h2"
                                    align="left"
                                >
                                    {record.desc}
                                </Typography>
                                <Box mt={2}>
                                <ReferenceField link="show" source="member_no" reference="user">
                                    <Profile />
                                </ReferenceField>
                                </Box>
                            </CardContent>
                            <CardActions
                                sx={{
                                    '.MuiCardActions-spacing': {
                                        display: 'flex',
                                        justifyContent: 'space-around',
                                    },
                                }}
                            >
                                <LibraryUseButton />
                            </CardActions>
                        </Card>
                    </Grid>
                </RecordContextProvider>
            ))}
        </Grid>
    );
}

export const LibraryList = props => {
    const navigate = useNavigate()
    const refresh = useRefresh();

    //Custom List Code Start

    //Custom List Code End
    return (
        <ListBase>
            <Box mt={2}>
                <LibraryToolbar/>
            </Box>
            <LibraryGrid />
        </ListBase>
    )
};

export const LibraryUseButton = props => {
    const [loading, setLoading] = useState(false)
    const record = useRecordContext();
    if (!record) return null;

    const useLibrary = async () => {
        setLoading(true)
        client.request_post('/api/library/import', { draft_id: record.id }).then(res => {
            setLoading(false)
        })
    }

    return (
        <Button variant="contained" color="primary" startIcon={loading && <CircularProgress size={24} />} onClick={useLibrary} disabled={loading}>
            Import to My Project</Button>
    )
}

export const LibraryShow = ({ ...props }) => {
    //Custom Show Init Start

    //Custom Show Init End
    return (
        <Show title={<LibraryTitle />} {...props} >
            <SimpleShowLayout>
                <TextField label="ID" source="id" />
                <TextField label="Name" source="name" false />
                <ReferenceField link="show" label="Sketch" source="sketch_udid" reference="sketch">
                    <TextField source="name" />
                </ReferenceField>
                <ReferenceField link="show" label="Member" source="member_no" reference="user">
                    <TextField source="email" />
                </ReferenceField>

                <ReferenceField link="edit" label="Preview" source="preview_start_screen_id" reference="screen">
                    <TextField source="name" />
                </ReferenceField>

                <ReferenceField link="edit" label="Preview" source="preview_start_screen_id" reference="screen">
                    <TextField source="name" />
                </ReferenceField>

                <DateField label="Create Date" source="reg_date" />
                <DateField label="Update Date" source="update_date" />

                <ArrayField label="Screen List" source={'screen_list'} >
                    <Datagrid bulkActionButtons={false}>
                        <ReferenceField linkType='show' label="Screen Name" source="screen_id" reference="screen" sortable={false}>
                            <TextField label="Name" source="name" />
                        </ReferenceField>
                    </Datagrid>
                </ArrayField>

                <ArrayField label="Block List" source={'block_list'} >
                    <Datagrid bulkActionButtons={false}>
                        <ReferenceField linkType='show' label="Block Name" source="block_id" reference="block" sortable={false}>
                            <TextField label="Name" source="name" />
                        </ReferenceField>
                    </Datagrid>
                </ArrayField>
            </SimpleShowLayout>
        </Show>
    )
};
